export const getThemePreviewColor = (themeClass, colorType) => {
  const themeColors = {
    'default': {
      primary: '#a855f7',
      secondary: '#ec4899',
      accent: '#8b5cf6'
    },
    'theme-ocean': {
      primary: '#0ea5e9',
      secondary: '#06b6d4',
      accent: '#3b82f6'
    },
    'theme-sunset': {
      primary: '#f97316',
      secondary: '#ef4444',
      accent: '#f59e0b'
    },
    'theme-forest': {
      primary: '#22c55e',
      secondary: '#10b981',
      accent: '#16a34a'
    },
    'theme-rose': {
      primary: '#f43f5e',
      secondary: '#ec4899',
      accent: '#e11d48'
    },
    'theme-cosmic': {
      primary: '#8b5cf6',
      secondary: '#a78bfa',
      accent: '#7c3aed'
    },
    'theme-cyber': {
      primary: '#00ffff',
      secondary: '#ff00ff',
      accent: '#00ff00'
    },
    'theme-golden': {
      primary: '#fbbf24',
      secondary: '#f59e0b',
      accent: '#d97706'
    },
    'theme-dark': {
      primary: '#374151',
      secondary: '#4b5563',
      accent: '#6b7280'
    },
    'theme-clear': {
      primary: '#e5e7eb',
      secondary: '#f3f4f6',
      accent: '#d1d5db'
    }
  }

  return themeColors[themeClass]?.[colorType] || '#a855f7'
}